import {RestService} from './_rest.service'
import {REST_API_END_POINTS} from './constants'
import {LoanerRecord} from "../api";

export class LoanerRecordService extends RestService<LoanerRecord> {
    constructor(url) {
        url ? super(url) : super(REST_API_END_POINTS.LOANER_RECORDS)
    }

    mark_return() {
        return this.instance.post(`${this.url}mark_return`)
    }

    mark_cancel() {
        return this.instance.post(`${this.url}mark_cancel`)
    }

    mark_lost() {
        return this.instance.post(`${this.url}mark_lost`)
    }

    send_record_details_by_email() {
        return this.instance.get(`${this.url}send_record_details_by_email/`)
    }
}
